<div class="mb-2">
    <p-table [value]="testActivationReport" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" responsiveLayout="scroll"
    styleClass="p-datatable-striped" [responsive]="true" [columns]="column"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" 
    [lazy]="true" (onLazyLoad)="onLazyLoad($event)" [lazyLoadOnInit]="false" [totalRecords]="totalRecords"
    [rowsPerPageOptions]="[10,25,50]" dataKey="index">

        <ng-template pTemplate="header" let-columns>
            <tr style="word-break: break-word;">
                <th style="width: 3em;"></th>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" class="font-bold">
                {{col.header}}
                <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-testActivationData let-expanded="expanded" let-rowIndex="rowIndex">
            <tr>
                <td>
                    <button type="button" pButton pRipple [pRowToggler]="testActivationData"
                        class="p-button-text p-button-rounded p-button-plain"
                        [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                </td>
                <td>{{testActivationData.partnerId}}</td>
                <td>{{testActivationData.pac}}</td>
                <td>{{testActivationData.productCode}}</td>
                <td>{{testActivationData.testStartDate | date: 'MMM dd yyyy HH:mm'}}</td>
                <td>{{testActivationData.testEndDate | date: 'MMM dd yyyy HH:mm'}}</td>
                <td>{{testActivationData.status}}</td>

            </tr>
        </ng-template>


        <ng-template pTemplate="rowexpansion" let-rowData let-columns="column">
            <tr>
                <td colspan="7" [attr.colspan]="column.length + 2" class="table-td">
                    <div class="grid">

                        <div class="col-12 md:col-6 lg:col-6">
                            <div class="grid" style="align-items: center;">
                                <div class="col-5" style="text-align: right">
                                    <label for="pac" class="lbl-fontfamily">Service Name
                                        :</label>
                                </div>
                                <div class="col-7 data-fontfamily" style="text-align:left;vertical-align: middle">
                                    {{rowData.serviceName}}
                                </div>
                            </div>
                        </div>
                        
                        <div class="col-12 md:col-6 lg:col-6">
                            <div class="grid" style="align-items: center;">
                                <div class="col-5" style="text-align: right">
                                    <label for="pac" class="lbl-fontfamily">Beams
                                        :</label>
                                </div>
                                <div class="col-7 data-fontfamily" style="text-align:left;vertical-align: middle">
                                    {{rowData.beams}}
                                </div>
                            </div>
                        </div>
                
                    </div>

                    <div class="grid">
                        <div class="col-12 md:col-6 lg:col-6">
                            <div class="grid" style="align-items: center;">
                                <div class="col-5" style="text-align: right">
                                    <label for="pac" class="lbl-fontfamily">DGNSS Service Level :</label>
                                </div>
                                <div class="col-7 data-fontfamily" style="text-align:left;vertical-align: middle">
                                    {{rowData.accessCodeName}}
                                </div>
                            </div>
                        </div>
                        <div class="col-12 md:col-6 lg:col-6">
                            <div class="grid" style="align-items: center;">
                                <div class="col-5" style="text-align: right">
                                    <label for="pac" class="lbl-fontfamily">Partner Name:
                                        :</label>
                                </div>
                                <div class="col-7 data-fontfamily" style="text-align:left;vertical-align: middle">
                                    {{rowData.organizationDisplayName}}
                                </div>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>